import { Component, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
	selector: 'missing-permission',
	template:
		'<div fxFlex fxLayoutAlign="center center" fxLayout="column"><mat-icon>security</mat-icon><h3>{{ "GLOBAL.MISSING_PERMISSION" | translate }}</h3><span style="margin-top: 50px;" class="hint-text" fxLayoutAlign="center center" *ngIf="storage.missingRoute != null">{{ storage.missingRoute }} <mat-icon class="gm5" (click)="retry()">refresh</mat-icon></span></div>',
})
export class MissingPermissionComponent implements OnDestroy {
	routeSubscription;
	public storage = {
		missingRoute: null,
	};
	constructor(private route: ActivatedRoute, private router: Router) {
		this.routeSubscription = this.route.queryParams.subscribe(params => {
			if (params && params.hasOwnProperty('url')) {
				this.storage.missingRoute = params.url;
			}
		});
	}

	ngOnDestroy() {
		this.routeSubscription.unsubscribe();
	}

	retry() {
		if (this.storage.missingRoute == null) return;
		this.router.navigate([this.storage.missingRoute]);
	}
}
